import { render } from "./FppDetail.vue?vue&type=template&id=10d3540e&scoped=true"
import script from "./FppDetail.vue?vue&type=script&lang=js"
export * from "./FppDetail.vue?vue&type=script&lang=js"

import "./FppDetail.vue?vue&type=style&index=0&id=10d3540e&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d3540e"]])

export default __exports__